import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import ThemeToggle from './ThemeToggle';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import logoDark from '../assets/logo-dark.png';
import logoLight from '../assets/logo-light.png';

const Header = () => {
    const { user, logout } = useAuth();
    const { theme } = useTheme();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const logo = theme === 'light' ? logoLight : logoDark;

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    return (
        <header className="header-container">
            {/* Left - Logo */}
            <Link to="/" className="header-logo" onClick={closeMenu}>
                <img src={logo} alt="RiyaMaga - Sri Lanka Vehicle Marketplace" className="header-logo-img" />
            </Link>

            {/* Mobile Actions */}
            <div className="mobile-header-actions">
                <Link to="/post-ad" className="mobile-header-post-btn" onClick={closeMenu}>
                    <i className="fa-solid fa-plus"></i> Post Ad
                </Link>
                <button className="mobile-menu-toggle" onClick={toggleMenu} aria-label="Toggle navigation">
                    <span className={`hamburger ${isMenuOpen ? 'open' : ''}`}></span>
                </button>
            </div>

            {/* Center - Navigation */}
            <nav className={`header-nav-container ${isMenuOpen ? 'open' : ''}`}>
                <ul className="header-nav">
                    <li><Link to="/buy" className="header-nav-link" onClick={closeMenu}>Buy a Vehicle</Link></li>
                    <li><Link to="/rent" className="header-nav-link" onClick={closeMenu}>Rent a Vehicle</Link></li>
                    <li><Link to="/parts" className="header-nav-link" onClick={closeMenu}>Parts</Link></li>
                    <li><Link to="/service-stations" className="header-nav-link" onClick={closeMenu}>Service Stations</Link></li>
                </ul>

                {/* Mobile-only CTA in menu */}
                <div className="mobile-nav-cta">
                    {user ? (
                        <div className="mobile-user-menu">
                            {user.role === 'admin' && (
                                <Link to="/admin" className="header-nav-link" onClick={closeMenu} style={{ color: '#ef4444', marginLeft: '1rem' }}>
                                    <i className="fa-solid fa-shield-halved"></i> Admin
                                </Link>
                            )}
                            <Link to="/profile" className="header-nav-link" onClick={closeMenu}>
                                Profile ({user.fullName ? user.fullName.split(' ')[0] : 'User'})
                            </Link>
                        </div>
                    ) : (
                        <Link to="/login" className="header-nav-link" onClick={closeMenu}>Login</Link>
                    )}
                    <Link to="/post-ad" className="btn-post-ad mobile-post-btn" onClick={closeMenu}>
                        Post Free Ad
                    </Link>
                    <div style={{ marginTop: '1rem' }}><ThemeToggle /></div>
                </div>
            </nav>

            {/* Right - Desktop CTA */}
            <div className="header-cta desktop-cta">
                <ThemeToggle />
                {user ? (
                    <div className="user-menu" style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        {user.role === 'admin' && (
                            <Link to="/admin" style={{ fontSize: '0.9rem', fontWeight: 600, textDecoration: 'none', color: '#ef4444', marginRight: '0.5rem' }}>
                                <i className="fa-solid fa-shield-halved"></i> Admin
                            </Link>
                        )}
                        <Link to="/profile" className="user-name" style={{ fontSize: '0.9rem', fontWeight: 500, textDecoration: 'none', color: 'var(--color-text-primary)' }}>
                            {user.fullName ? user.fullName.split(' ')[0] : 'User'}
                        </Link>
                    </div>
                ) : (
                    <Link to="/login" className="header-nav-link">Login</Link>
                )}

                <Link to="/post-ad" className="btn-post-ad">
                    Post Free Ad
                </Link>
            </div>
        </header>
    );
};

export default Header;
